import { render, staticRenderFns } from "./userBase.vue?vue&type=template&id=5d35a87a&"
import script from "./userBase.vue?vue&type=script&lang=js&"
export * from "./userBase.vue?vue&type=script&lang=js&"
import style0 from "./userBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports